import { render, staticRenderFns } from "./thirdCardAllAlert.vue?vue&type=template&id=2fec7775&scoped=true"
import script from "./thirdCardAllAlert.vue?vue&type=script&lang=js"
export * from "./thirdCardAllAlert.vue?vue&type=script&lang=js"
import style0 from "./thirdCardAllAlert.vue?vue&type=style&index=0&id=2fec7775&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec7775",
  null
  
)

export default component.exports